import { init } from 'store/app/actions/init'
import { AppSlice } from 'store/app/slice/slice'

export const AppActions = {
  ...AppSlice.actions,
  init,
}
